import 'react-app-polyfill/ie11';
import arrayPrototypeFind from 'array.prototype.find';
import arrayPrototypeFindIndex from 'array.prototype.findindex';
import 'canvas-toBlob';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConnectedRouter } from 'react-router-redux';
import configureStore, { history } from './redux/configureStore';
import App from './App';

arrayPrototypeFind.shim();
arrayPrototypeFindIndex.shim();

Number.isNaN = Number.isNaN || function isNaN(value) {
  // eslint-disable-next-line no-self-compare
  return value !== value;
};

const root = document.querySelector('#root');

const { store, persistor } = configureStore();

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  root,
);

if (module.hot) {
  module.hot.accept('./App', () => {
    render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>,
      root,
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js